export const QUERY_KEY = {
  ME: "me",
  CHECK_IN_INFO: "check-in-info",
  LEADERBOARD: "leaderboard",
  USER_ACTIVITY: "user-activity",
  USER_STATISTICS: "user-statistics",
  ASSETS_ALLOCATION: "assets-allocation",
  TVL_STATISTICS: "tvl-statistics",
  REF_COMMISSION: "ref-commission",
  WITHDRAW_STATUS: "withdraw-status"
};
